import { db } from './firebase';
import {
  collection,
  doc,
  getDoc,
  getDocs,
  updateDoc,
  query,
  where,
  Timestamp,
} from 'firebase/firestore';

export const userService = {
  // Get user profile
  getUserProfile: async (uid) => {
    const userDoc = await getDoc(doc(db, 'users', uid));
    return userDoc.exists() ? { id: userDoc.id, ...userDoc.data() } : null;
  },

  // Update user profile
  updateProfile: async (uid, profileData) => {
    await updateDoc(doc(db, 'users', uid), {
      ...profileData,
      updatedAt: Timestamp.now(),
    });
  },

  // Get all users (Admin)
  getAllUsers: async () => {
    const usersRef = collection(db, 'users');
    const snapshot = await getDocs(usersRef);
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));
  },

  // Search users (Admin)
  searchUsers: async (searchTerm) => {
    const q = query(
      collection(db, 'users'),
      where('email', '>=', searchTerm),
      where('email', '<=', searchTerm + '\uf8ff')
    );

    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));
  },

  // Assign role (Admin only)
  assignRole: async (uid, role) => {
    await updateDoc(doc(db, 'users', uid), {
      role,
      updatedAt: Timestamp.now(),
    });
  },

  // Get users by role
  getUsersByRole: async (role) => {
    const q = query(
      collection(db, 'users'),
      where('role', '==', role)
    );

    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));
  },

  // Add saved passenger
  addSavedPassenger: async (uid, passengerData) => {
    const userDoc = await getDoc(doc(db, 'users', uid));
    const savedPassengers = userDoc.data()?.savedPassengers || [];

    savedPassengers.push({
      id: `passenger_${Date.now()}`,
      ...passengerData,
    });

    await updateDoc(doc(db, 'users', uid), {
      savedPassengers,
    });
  },

  // Get saved passengers
  getSavedPassengers: async (uid) => {
    const userDoc = await getDoc(doc(db, 'users', uid));
    return userDoc.data()?.savedPassengers || [];
  },

  // Delete saved passenger
  deleteSavedPassenger: async (uid, passengerId) => {
    const userDoc = await getDoc(doc(db, 'users', uid));
    const savedPassengers = (userDoc.data()?.savedPassengers || []).filter(
      p => p.id !== passengerId
    );

    await updateDoc(doc(db, 'users', uid), {
      savedPassengers,
    });
  },
};

export default userService;
